import { createSlice } from "@reduxjs/toolkit";
import { ADD_SIGN_CONTRACTS_ACTION, GET_SIGN_CONTRACTS_ACTION, UPDATE_SIGN_CONTRACTS_ACTION } from "./Content.action";

const ContentSlice = createSlice({
    name: "content",
    initialState: {
        content: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_SIGN_CONTRACTS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_SIGN_CONTRACTS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.content = action.payload;
            })
            .addCase(GET_SIGN_CONTRACTS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(ADD_SIGN_CONTRACTS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ADD_SIGN_CONTRACTS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(ADD_SIGN_CONTRACTS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(UPDATE_SIGN_CONTRACTS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(UPDATE_SIGN_CONTRACTS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(UPDATE_SIGN_CONTRACTS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default ContentSlice;